import CustomEventCell from './component'

export default CustomEventCell
